import styled, { css } from 'styled-components';
import { position } from 'polished';
import { media, size } from '@deerplusofficial/pos-helper';

export default styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  overflow: auto;
  ${position('absolute', '0', null, null, '0')};
  ${media(
    'tablet',
    css`
      padding: ${size.padding.y} ${size.padding.x};
    `
  )};
`;



// WEBPACK FOOTER //
// ./src/components/Container/Container.js